import { supabase } from '@/integrations/supabase/client';

export interface VerificationResult {
    keyId: string;
    gameTitle: string;
    userName: string;
    status: 'verified' | 'failed' | 'skipped';
    reason?: string;
}

export interface VerificationSummary {
    total: number;
    verified: number;
    failed: number;
    skipped: number;
}

export interface VerificationResponse {
    success: boolean;
    summary: VerificationSummary;
    results: VerificationResult[];
}

/**
 * Start the Steam key verification process
 * This calls the Supabase Edge Function to verify all claimed keys
 */
export async function startKeyVerification(): Promise<VerificationResponse> {
    try {
        const { data, error } = await supabase.functions.invoke('verify-steam-keys', {
            body: {}
        });

        if (error) {
            console.error('Edge Function error:', error);
            throw new Error(`Edge Function error: ${error.message || JSON.stringify(error)}`);
        }

        if (!data) {
            throw new Error('No data returned from Edge Function');
        }

        // Log the response for debugging
        console.log('Verification response:', data);

        return data as VerificationResponse;
    } catch (error: any) {
        console.error('Error starting key verification:', error);
        throw new Error(error.message || 'Unknown error during verification');
    }
}

/**
 * Get all claimed keys with their current activation status
 */
export async function getClaimedKeys() {
    try {
        const { data, error } = await supabase
            .from('keys')
            .select(`
        id,
        key_code,
        is_claimed,
        is_activated,
        claimed_at,
        games (
          id,
          title,
          steam_game_id
        ),
        profiles:claimed_by (
          id,
          display_name,
          steam_id
        )
      `)
            .eq('is_claimed', true)
            .order('claimed_at', { ascending: false });

        if (error) {
            throw error;
        }

        return data || [];
    } catch (error) {
        console.error('Error fetching claimed keys:', error);
        throw error;
    }
}
